import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '@/components/Hero';
import Marquee from '@/components/Marquee';
import Stats from '@/components/Stats';
import Why from '@/components/Why';
import Philosophy from '@/components/Philosophy';
import AgeGroups from '@/components/AgeGroups';
import Pricing from '@/components/Pricing';
import GirlsWinter from '@/components/GirlsWinter';
import Programs from '@/components/Programs';
import Pathway from '@/components/Pathway';
import Coaches from '@/components/Coaches';
import SmallGroup from '@/components/SmallGroup';
import Character from '@/components/Character';
import ParentPromise from '@/components/ParentPromise';
import PlayerProgress from '@/components/PlayerProgress';
import Testimonials from '@/components/Testimonials';
import Gallery from '@/components/Gallery';
import RegisterSection from '@/components/RegisterSection';
import Contact from '@/components/Contact';
import InstagramCTA from '@/components/InstagramCTA';
import { scrollToHash } from '@/lib/motion';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => scrollToHash(location.hash), 250);
      return () => clearTimeout(t);
    }
  }, [location.hash]);

  useEffect(() => {
    document.title = 'Soccer Academy in Canton, Michigan | Abu Zama Soccer Academy';
  }, []);

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Stats />
      <Why />
      <Philosophy />
      <AgeGroups />
      <Pricing />
      <GirlsWinter />
      <Programs />
      <Pathway />
      <Coaches />
      <SmallGroup />
      <Character />
      <ParentPromise />
      <PlayerProgress />
      <Testimonials />
      <Gallery />
      <RegisterSection />
      <InstagramCTA />
      <Contact />
    </main>
  );
}
